var map = {
	"./big_ace.png": 7106,
	"./big_ace@2x.png": 1516,
	"./crown.png": 24,
	"./crown@2x.png": 8603,
	"./diamond.png": 7643,
	"./diamond@2x.png": 408,
	"./gifts_box_lift.png": 5647,
	"./gifts_box_lift@2x.png": 8744,
	"./gifts_box_right.png": 322,
	"./gifts_box_right@2x.png": 5926,
	"./gold.png": 8411,
	"./lollipop.png": 6067,
	"./lollipop@2x.png": 12,
	"./pink_heart.png": 6175,
	"./pink_heart@2x.png": 1062,
	"./plastic_flower.png": 2253,
	"./plastic_flower@2x.png": 8737,
	"./star.png": 7946,
	"./star@2x.png": 6841,
	"./the_push_box.png": 8859,
	"./the_push_box@2x.png": 9237
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9339;